import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  colorInputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '16px',
    '& .MuiOutlinedInput-root': {
      margin: 0,
      padding: 0,
      width: '100%',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px',
        border: 'none'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px'
      }
    },
    '& .MuiInputBase-input': {
      padding: '0px 8px',
      height: '32px',
      minHeight: '32px',
      maxHeight: '32px',
      border: 'none',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        padding: '0px 8px'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px',
        border: 'none'
      }
    }
  },
  dialog: {
    '& .MuiDialogContent-root': {
      padding: '8px 24px 12px',
      paddingTop: '8px'
    }
  },
  colorInput: {
    flex: 4
  },
  rgbColorInputContainer: {
    display: 'flex',
    flex: 4,
    gap: '8px'
  },
  colorFormatSelect: {
    flex: 1,
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0
    }
  },
  colorPreview: {
    minWidth: '32px',
    width: '32px',
    height: '32px',
    borderRadius: '4px'
  },
  colorModalContainer: {
    position: 'relative',
    width: '100%',
    height: '184px'
  },
  recentColorsContainer: {
    display: 'flex',
    gap: '16px',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  recentColorsMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  colorCodeInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '16px'
  },
  labelText: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
    lineHeight: '24px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium
  },
  dialogTitle: {
    '& .MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    }
  }

});
